const Address = {
	sido: [
		{ key: "서울", value: "101000" },
		{ key: "경기", value: "102000" },
		{ key: "광주", value: "103000" },
		{ key: "대구", value: "104000" },
		{ key: "대전", value: "105000" },
		{ key: "부산", value: "106000" },
		{ key: "울산", value: "107000" },
		{ key: "인천", value: "108000" },
		{ key: "강원", value: "109000" },
		{ key: "경남", value: "110000" },
		// { key: "경북", value: "111000" },
		{ key: "전남", value: "112000" },
		{ key: "전북", value: "113000" },
		{ key: "충북", value: "114000" },
		{ key: "충남", value: "115000" },
		{ key: "제주", value: "116000" },
		{ key: "세종", value: "118000" },
	],

	gungu: {
		"101000": [
			{ value: "101001", key: "서울전체" },
			{ value: "101010", key: "강남구" },
			{ value: "101020", key: "강동구" },
			{ value: "101030", key: "강북구" },
			{ value: "101040", key: "강서구" },
			{ value: "101050", key: "관악구" },
			{ value: "101060", key: "광진구" },
			{ value: "101070", key: "구로구" },
			{ value: "101080", key: "금천구" },
			{ value: "101090", key: "노원구" },
			{ value: "101100", key: "도봉구" },
			{ value: "101110", key: "동대문구" },
			{ value: "101120", key: "동작구" },
			{ value: "101130", key: "마포구" },
			{ value: "101140", key: "서대문구" },
			{ value: "101150", key: "서초구" },
			{ value: "101160", key: "성동구" },
			{ value: "101170", key: "성북구" },
			{ value: "101180", key: "송파구" },
			{ value: "101190", key: "양천구" },
			{ value: "101200", key: "영등포구" },
			{ value: "101210", key: "용산구" },
			{ value: "101220", key: "은평구" },
			{ value: "101230", key: "종로구" },
			{ value: "101240", key: "중구" },
			{ value: "101250", key: "중랑구" },
		],
		"102000": [
			{ value: "102001", key: "경기전체" },
			{ value: "102010", key: "가평군" },
			{ value: "102020", key: "고양시" },
			{ value: "102030", key: "고양시 덕양구" },
			{ value: "102040", key: "고양시 일산동구" },
			{ value: "102050", key: "고양시 일산서구" },
			{ value: "102060", key: "과천시" },
			{ value: "102070", key: "광명시" },
			{ value: "102080", key: "광주시" },
			{ value: "102090", key: "구리시" },
			{ value: "102100", key: "군포시" },
			{ value: "102110", key: "김포시" },
			{ value: "102120", key: "남양주시" },
			{ value: "102130", key: "동두천시" },
			{ value: "102140", key: "부천시" },
			{ value: "102150", key: "부천시 소사구" },
			{ value: "102160", key: "부천시 오정구" },
			{ value: "102170", key: "부천시 원미구" },
			{ value: "102180", key: "성남시" },
			{ value: "102190", key: "성남시 분당구" },
			{ value: "102200", key: "성남시 수정구" },
			{ value: "102210", key: "성남시 중원구" },
			{ value: "102220", key: "수원시" },
			{ value: "102230", key: "수원시 권선구" },
			{ value: "102240", key: "수원시 영통구" },
			{ value: "102250", key: "수원시 장안구" },
			{ value: "102260", key: "수원시 팔달구" },
			{ value: "102270", key: "시흥시" },
			{ value: "102280", key: "안산시" },
			{ value: "102290", key: "안산시 단원구" },
			{ value: "102300", key: "안산시 상록구" },
			{ value: "102310", key: "안성시" },
			{ value: "102320", key: "안양시" },
			{ value: "102330", key: "안양시 동안구" },
			{ value: "102340", key: "안양시 만안구" },
			{ value: "102350", key: "양주시" },
			{ value: "102360", key: "양평군" },
			{ value: "102370", key: "여주시" },
			{ value: "102380", key: "연천군" },
			{ value: "102390", key: "오산시" },
			{ value: "102400", key: "용인시" },
			{ value: "102410", key: "용인시 기흥구" },
			{ value: "102420", key: "용인시 수지구" },
			{ value: "102430", key: "용인시 처인구" },
			{ value: "102440", key: "의왕시" },
			{ value: "102450", key: "의정부시" },
			{ value: "102460", key: "이천시" },
			{ value: "102470", key: "파주시" },
			{ value: "102480", key: "평택시" },
			{ value: "102490", key: "포천시" },
			{ value: "102500", key: "하남시" },
			{ value: "102510", key: "화성시" },
		],
		"103000": [
			{ value: "103001", key: "광주전체" },
			{ value: "103010", key: "광산구" },
			{ value: "103020", key: "남구" },
			{ value: "103030", key: "동구" },
			{ value: "103040", key: "북구" },
			{ value: "103050", key: "서구" },
		],
		"104000": [
			{ value: "104001", key: "대구전체" },
			{ value: "104010", key: "남구" },
			{ value: "104020", key: "달서구" },
			{ value: "104030", key: "달성군" },
			{ value: "104040", key: "동구" },
			{ value: "104050", key: "북구" },
			{ value: "104060", key: "서구" },
			{ value: "104070", key: "수성구" },
			{ value: "104080", key: "중구" },
		],
		"105000": [
			{ value: "105001", key: "대전전체" },
			{ value: "105010", key: "대덕구" },
			{ value: "105020", key: "동구" },
			{ value: "105030", key: "서구" },
			{ value: "105040", key: "유성구" },
			{ value: "105050", key: "중구" },
		],
		"106000": [
			{ value: "106001", key: "부산전체" },
			{ value: "106010", key: "강서구" },
			{ value: "106020", key: "금정구" },
			{ value: "106030", key: "기장군" },
			{ value: "106040", key: "남구" },
			{ value: "106050", key: "동구" },
			{ value: "106060", key: "동래구" },
			{ value: "106070", key: "부산진구" },
			{ value: "106080", key: "북구" },
			{ value: "106090", key: "사상구" },
			{ value: "106100", key: "사하구" },
			{ value: "106110", key: "서구" },
			{ value: "106120", key: "수영구" },
			{ value: "106130", key: "연제구" },
			{ value: "106140", key: "영도구" },
			{ value: "106150", key: "중구" },
			{ value: "106160", key: "해운대구" },
		],
		"107000": [
			{ value: "107001", key: "울산전체" },
			{ value: "107010", key: "남구" },
			{ value: "107020", key: "동구" },
			{ value: "107030", key: "북구" },
			{ value: "107040", key: "울주군" },
			{ value: "107050", key: "중구" },
		],
		"108000": [
			{ value: "108001", key: "인천전체" },
			{ value: "108010", key: "강화군" },
			{ value: "108020", key: "계양구" },
			{ value: "108030", key: "남구" },
			{ value: "108040", key: "남동구" },
			{ value: "108050", key: "동구" },
			{ value: "108060", key: "부평구" },
			{ value: "108070", key: "서구" },
			{ value: "108080", key: "연수구" },
			{ value: "108090", key: "옹진군" },
			{ value: "108100", key: "중구" },
		],
		"109000": [
			{ value: "109001", key: "강원전체" },
			{ value: "109010", key: "강릉시" },
			{ value: "109020", key: "고성군" },
			{ value: "109030", key: "동해시" },
			{ value: "109040", key: "삼척시" },
			{ value: "109050", key: "속초시" },
			{ value: "109060", key: "양구군" },
			{ value: "109070", key: "양양군" },
			{ value: "109080", key: "영월군" },
			{ value: "109090", key: "원주시" },
			{ value: "109100", key: "인제군" },
			{ value: "109110", key: "정선군" },
			{ value: "109120", key: "철원군" },
			{ value: "109130", key: "춘천시" },
			{ value: "109140", key: "태백시" },
			{ value: "109150", key: "평창군" },
			{ value: "109160", key: "홍천군" },
			{ value: "109170", key: "화천군" },
			{ value: "109180", key: "횡성군" },
		],
		"110000": [
			{ value: "110001", key: "경남전체" },
			{ value: "110010", key: "거제시" },
			{ value: "110020", key: "거창군" },
			{ value: "110030", key: "고성군" },
			{ value: "110040", key: "김해시" },
			{ value: "110050", key: "남해군" },
			{ value: "110053", key: "창원시 마산회원구" },
			{ value: "110055", key: "창원시 마산합포구" },
			{ value: "110057", key: "창원시 성산구" },
			{ value: "110059", key: "창원시 의창구" },
			{ value: "110070", key: "밀양시" },
			{ value: "110080", key: "사천시" },
			{ value: "110090", key: "산청군" },
			{ value: "110100", key: "양산시" },
			{ value: "110110", key: "의령군" },
			{ value: "110120", key: "진주시" },
			{ value: "110130", key: "창원시 진해구" },
			{ value: "110140", key: "창녕군" },
			{ value: "110150", key: "창원시" },
			{ value: "110160", key: "통영시" },
			{ value: "110170", key: "하동군" },
			{ value: "110180", key: "함안군" },
			{ value: "110190", key: "함양군" },
			{ value: "110200", key: "합천군" },
			{ value: "111001", key: "경북전체" },
			{ value: "111010", key: "경산시" },
			{ value: "111020", key: "경주시" },
			{ value: "111030", key: "고령군" },
			{ value: "111040", key: "구미시" },
			{ value: "111050", key: "군위군" },
			{ value: "111060", key: "김천시" },
			{ value: "111070", key: "문경시" },
			{ value: "111080", key: "봉화군" },
			{ value: "111090", key: "상주시" },
			{ value: "111100", key: "성주군" },
			{ value: "111110", key: "안동시" },
			{ value: "111120", key: "영덕군" },
			{ value: "111130", key: "영양군" },
			{ value: "111140", key: "영주시" },
			{ value: "111150", key: "영천시" },
			{ value: "111160", key: "예천군" },
			{ value: "111170", key: "울릉군" },
			{ value: "111180", key: "울진군" },
			{ value: "111190", key: "의성군" },
			{ value: "111200", key: "청도군" },
			{ value: "111210", key: "청송군" },
			{ value: "111220", key: "칠곡군" },
			{ value: "111230", key: "포항시" },
			{ value: "111240", key: "포항시 남구" },
			{ value: "111250", key: "포항시 북구" },
		],
		"112000": [
			{ value: "112001", key: "전남전체" },
			{ value: "112010", key: "강진군" },
			{ value: "112020", key: "고흥군" },
			{ value: "112030", key: "곡성군" },
			{ value: "112040", key: "광양시" },
			{ value: "112050", key: "구례군" },
			{ value: "112060", key: "나주시" },
			{ value: "112070", key: "담양군" },
			{ value: "112080", key: "목포시" },
			{ value: "112090", key: "무안군" },
			{ value: "112100", key: "보성군" },
			{ value: "112110", key: "순천시" },
			{ value: "112120", key: "신안군" },
			{ value: "112130", key: "여수시" },
			{ value: "112140", key: "영광군" },
			{ value: "112150", key: "영암군" },
			{ value: "112160", key: "완도군" },
			{ value: "112170", key: "장성군" },
			{ value: "112180", key: "장흥군" },
			{ value: "112190", key: "진도군" },
			{ value: "112200", key: "함평군" },
			{ value: "112210", key: "해남군" },
			{ value: "112220", key: "화순군" },
		],
		"113000": [
			{ value: "113001", key: "전북전체" },
			{ value: "113010", key: "고창군" },
			{ value: "113020", key: "군산시" },
			{ value: "113030", key: "김제시" },
			{ value: "113040", key: "남원시" },
			{ value: "113050", key: "무주군" },
			{ value: "113060", key: "부안군" },
			{ value: "113070", key: "순창군" },
			{ value: "113080", key: "완주군" },
			{ value: "113090", key: "익산시" },
			{ value: "113100", key: "임실군" },
			{ value: "113110", key: "장수군" },
			{ value: "113120", key: "전주시" },
			{ value: "113130", key: "전주시 덕진구" },
			{ value: "113140", key: "전주시 완산구" },
			{ value: "113150", key: "정읍시" },
			{ value: "113160", key: "진안군" },
		],
		"114000": [
			{ value: "114001", key: "충북전체" },
			{ value: "114010", key: "괴산군" },
			{ value: "114020", key: "단양군" },
			{ value: "114030", key: "보은군" },
			{ value: "114040", key: "영동군" },
			{ value: "114050", key: "옥천군" },
			{ value: "114060", key: "음성군" },
			{ value: "114070", key: "제천시" },
			{ value: "114080", key: "증평군" },
			{ value: "114090", key: "진천군" },
			{ value: "114100", key: "청원군" },
			{ value: "114110", key: "청주시" },
			{ value: "114120", key: "청주시 상당구" },
			{ value: "114130", key: "청주시 흥덕구" },
			{ value: "114140", key: "충주시" },
			{ value: "114150", key: "청주시 청원구" },
			{ value: "114160", key: "청주시 서원구" },
		],
		"115000": [
			{ value: "115001", key: "충남전체" },
			{ value: "115010", key: "계룡시" },
			{ value: "115020", key: "공주시" },
			{ value: "115030", key: "금산군" },
			{ value: "115040", key: "논산시" },
			{ value: "115050", key: "당진시" },
			{ value: "115060", key: "보령시" },
			{ value: "115070", key: "부여군" },
			{ value: "115080", key: "서산시" },
			{ value: "115090", key: "서천군" },
			{ value: "115100", key: "아산시" },
			{ value: "115110", key: "연기군" },
			{ value: "115120", key: "예산군" },
			{ value: "115130", key: "천안시" },
			{ value: "115133", key: "천안시 동남구" },
			{ value: "115135", key: "천안시 서북구" },
			{ value: "115140", key: "청양군" },
			{ value: "115150", key: "태안군" },
			{ value: "115160", key: "홍성군" },
		],
		"116000": [ 
			{ value: "116001", key: "제주전체" },
			{ value: "116030", key: "서귀포시" },
			{ value: "116040", key: "제주시" },
		],
		"117000": [
			{ value: "117000", key: "전국" },
		],
		"118000": [
			{ value: "118001", key: "세종전체" },
		]
	}
}

export default Address